import { AxiosResponse } from 'axios';
import { DocumentDeathFormVM } from 'civil-status/view-models/document-birth-form';
import { DateTime } from 'luxon';
import { DocumentDeathCM } from 'shell/models/document-death';
import { HttpResponse } from 'shell/models/http-response';

export const transformDocumentDeath = (
  response: AxiosResponse<HttpResponse<DocumentDeathCM>>
): DocumentDeathFormVM => {
  const payloadResponse = response.data?.payload;

  const item: DocumentDeathFormVM = {
    indicatorUpdate:
      payloadResponse?.datiAttoMorte?.indicatoreAggiornamento === '0' ||
      !payloadResponse?.datiAttoMorte?.indicatoreAggiornamento
        ? 'È necessario effettuare la convalida dei dati.'
        : '',
    matricola: payloadResponse?.datiAttoMorte?.matricola?.toString() || '',
    surname: payloadResponse?.datiAttoMorte?.cognome || '',
    name: payloadResponse?.datiAttoMorte?.nome || '',
    gender: payloadResponse?.datiAttoMorte?.sesso || '',
    municipalityBirth: payloadResponse?.datiAttoMorte?.comuneNascita || '',
    // surnameFather: payloadResponse?.datiAttoMorte?.cognomePadre || '',
    // nameFather: payloadResponse?.datiAttoMorte?.nomePadre || '',
    // surnameMother: payloadResponse?.datiAttoMorte?.cognomeMadre || '',
    // nameMother: payloadResponse?.datiAttoMorte?.nomeMadre || '',
    spouseSurname: payloadResponse?.datiAttoMorte?.cognomeConiuge || '',
    spouseName: payloadResponse?.datiAttoMorte?.nomeConiuge || '',
    deathPresumed: payloadResponse?.datiAttoMorte?.indicatoreMortePresunta === '1',
    hourDeathUnknown: payloadResponse?.datiAttoMorte?.flagOreImprecisate === '1',
    deathDate:
      payloadResponse?.datiAttoMorte?.dataMorte && !payloadResponse?.datiAttoMorte?.secondaDataMorte
        ? DateTime.fromISO(payloadResponse?.datiAttoMorte?.dataMorte)
        : null,
    deathBy:
      payloadResponse?.datiAttoMorte?.dataMorte && payloadResponse?.datiAttoMorte?.secondaDataMorte
        ? DateTime.fromISO(payloadResponse?.datiAttoMorte?.dataMorte)
        : null,
    deathTo: payloadResponse?.datiAttoMorte?.secondaDataMorte
      ? DateTime.fromISO(payloadResponse?.datiAttoMorte?.secondaDataMorte)
      : null,
    deathMunicipality: payloadResponse?.datiAttoMorte?.comuneMorte || '',
    residenceMunicipality: payloadResponse?.datiAttoMorte?.comuneResidenza || '',
    hourDeathDate:
      payloadResponse?.datiAttoMorte?.indicatoreMortePresunta !== '1'
        ? payloadResponse?.datiAttoMorte?.oraMorte
          ? DateTime.fromISO(payloadResponse?.datiAttoMorte?.oraMorte)
          : null
        : null,
    status: payloadResponse?.datiAttoMorte?.statoCivile || '',
    birthday: payloadResponse?.datiAttoMorte?.dataNascita
      ? DateTime.fromISO(payloadResponse?.datiAttoMorte?.dataNascita)
      : null,
    years: payloadResponse?.datiAttoMorte?.anni || '',
    yearDate: payloadResponse?.datiAttoMorte?.annoNascita || '',
    year: payloadResponse?.datiAttoMorte?.key?.anno || '',
    registerNumber: payloadResponse?.datiAttoMorte?.key?.numeroRegistro || '',
    documentNumber: payloadResponse?.datiAttoMorte?.key?.numeroAtto?.toString() || '',
    portion: payloadResponse?.datiAttoMorte?.key?.parte || '',
    serie: payloadResponse?.datiAttoMorte?.key?.serie1?.trim() || '',
    serie2: payloadResponse?.datiAttoMorte?.key?.serie2?.trim() || '',
    uploadFile:
      payloadResponse?.attoMorteCM?.attoByteArray && payloadResponse?.attoMorteCM?.atto
        ? {
            raw:
              payloadResponse?.attoMorteCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
            rawTiff: `data:image/png;base64,${payloadResponse?.attoMorteCM?.attoByteArray}`,
            file: new File(
              payloadResponse?.attoMorteCM?.atto?.map(
                (element: string) => `data:image/png;base64,${element}`
              ) || [],
              payloadResponse?.attoMorteCM?.nomeFile
            ),
          }
        : undefined,
    annotationInternationalList:
      payloadResponse?.annotazioniAttoMorteInt?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
    annotationNationalList:
      payloadResponse?.annotazioniAttoMorteNaz?.map((annotation, index) => ({
        id: index + 1,
        value: annotation.testo,
        position: annotation.key.posizione,
        hidden: {
          read: true,
        },
      })) || [],
  };
  return item;
};

export const transformDocumentDeathRequestUpdate = (values: DocumentDeathFormVM) =>
  ({
    key: {
      numeroAtto: values.documentNumber || '',
      numeroRegistro: values.registerNumber || '',
      parte: values.portion || '',
      serie1: values.serie || '',
      serie2: values.serie2 || ' ',
      anno: values.year || '',
    },
    indicatoreMortePresunta: values?.deathPresumed ? '1' : '0',
    dataMorte: values?.deathBy
      ? values?.deathBy?.toFormat('yyyy-MM-dd')
      : values.deathDate
      ? values.deathDate?.toFormat('yyyy-MM-dd')
      : '',
    secondaDataMorte: values.deathTo ? values.deathTo?.toFormat('yyyy-MM-dd') : '',
    oraMorte: values.hourDeathDate || undefined,
    flagOreImprecisate: values.hourDeathUnknown ? '1' : '0',
    comuneMorte: values.deathMunicipality || '',
    matricola: values.matricola || '',
    cognome: values.surname || '',
    nome: values.name || '',
    dataNascita: values.birthday ? values.birthday?.toFormat('yyyy-MM-dd') : '',
    anni: values.years || '',
    annoNascita: values?.yearDate || '',
    sesso: values.gender || '',
    comuneNascita: values.municipalityBirth || '',
    comuneResidenza: values.residenceMunicipality || '',
    statoCivile: values.status || '',
    cognomeConiuge: values.spouseSurname || '',
    nomeConiuge: values.spouseName || '',
    // cognomePadre: values.surnameFather || '',
    // nomePadre: values.nameFather || '',
    // cognomeMadre: values.surnameMother || '',
    // nomeMadre: values.nameMother || '',
  } as const);
